import Vue from 'vue';
import VueNativeSock from 'vue-native-websocket';
import App from './App.vue';
import store from './store';


Vue.config.productionTip = false;

const APP_CONFIG = window.APP_CONFIG || {};

Vue.prototype.$country = APP_CONFIG.COUNTRY || 'ru';
const BACKEND_URL = APP_CONFIG.BACKEND_URL || 'ws://localhost:3001';
Vue.prototype.$country = process.env.VUE_APP_COUNTRY || 'ru';

if (Vue.prototype.$country === 'ru') {
  require('@/assets/fonts/RU/fonts.css');
}

const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get('token');
if (!token) {
  throw new Error('token is not defined in query parameters');
}
const vip = urlParams.get('vip') || 0;
const wsUrl = new URL(BACKEND_URL);
wsUrl.searchParams.set('token', token);
wsUrl.searchParams.set('vip', vip);

Vue.use(VueNativeSock, wsUrl.toString(),
  {
    store,
    format: 'json',
    reconnection: true,
  });
new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');
